import { Injectable } from '@angular/core';

@Injectable()
export class ApiService {

  constructor() { }

  buildParameterListFromMap(params: Map<string, string>, startOfQueryString: boolean): string {
    if (!params) return '';
    let uriPart: string = startOfQueryString ? '?' : '&';
    let first = true;
    params.forEach((value, name) => {
      if (!first) uriPart += '&';
      uriPart += name + '=' + value;
      first = false;
    });

    return uriPart;
  }

  buildParameterList(params: ParamList[]): string {
    let uriPart: string = '';
    let first = true;

    params.forEach(param => {
      if (param.paramValues) {
        param.paramValues.forEach(value => {
          first ? uriPart += '?' : uriPart += '&';
          uriPart += param.paramName + '=' + value;
          first = false;
        });
      }
    });

    return uriPart;
  }
}

export class ParamList {
  paramName: string;
  paramValues: any[];

  constructor(name: string, values: any[]) {
    this.paramName = name;
    this.paramValues = values;
  }
}
